let store = {
  namespaced: true,
  state: {
    content: {
      id: null,
      name: null,
      id_alt: null
    }
  },
  mutations: {
    setPatientData (state, payload) {
      state.content = payload
    }
  },
  actions: {
  }
}

export default store



// WEBPACK FOOTER //
// ./src/store/modules/patient.js